import React from "react";
import NodeCardActive from "../../chart/node/NodeCardActive.js";
import NodeCardEnd from "../../chart/node/NodeCardEnd.js";
import NodeCollapseWithArrow from "../../chart/node/NodeCollapseWithArrow.js";

export default function Node({
  children,
  disableDefaultOptionsButtons,
  extraContent,
  isEndNode,
  isLastOnPath,
  isOnPath,
  links,
  linksActive,
  nodeId,
  nodeTitle,
  onGoTo,
  onNext,
  onReset,
  options,
}) {
  const onNodeGoTo = () => onGoTo(nodeId);

  if (!isOnPath) {
    return null;
  } else if (isOnPath && !isLastOnPath) {
    return (
      <NodeCollapseWithArrow
        nodeId={nodeId}
        nodeTitle={nodeTitle}
        children={children}
        onNext={onNext}
        links={links}
        isLastOnPath={isLastOnPath}
        linksActive={linksActive}
        onNodeGoTo={onNodeGoTo}
      />
    );
  } else if (isEndNode) {
    return (
      <NodeCardEnd
        nodeId={nodeId}
        nodeTitle={nodeTitle}
        children={children}
        onReset={onReset}
      />
    );
  } else if (isLastOnPath) {
    return (
      <NodeCardActive
        nodeId={nodeId}
        nodeTitle={nodeTitle}
        children={children}
        onReset={onReset}
        options={options}
        extraContent={extraContent}
        disableDefaultOptionsButtons={disableDefaultOptionsButtons}
        links={links}
        onNext={onNext}
      />
    );
  }
}
